//DokumentPrisutstvuyushchieNaZasedaniiRegPravleniya
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Form, Input, Select } from 'antd';

import REDUX_ZasedaniyaRegionalnogoPravleniya from '../../../objects/ZasedaniyaRegionalnogoPravleniya/reducer'

const { Option } = Select;


export default function DokumentPrisutstvuyushchieNaZasedaniiRegPravleniya(props) {
    const { auth, object, zasedanie } = props;
    // const zasedanie = useSelector(REDUX_ZasedaniyaRegionalnogoPravleniya.selector.objectByKey(object.ID));
    
    const [chleni, setChleni] = useState([]);

    useEffect(() => {
        auth.fetch('/api/query/ChleniFederatsii?detail=model&w-nu-dokumentVikhodaIzFederatsii.ID&w-nnu-dokumentVstupleniya.ID').then(res => {
            if (res && res.data) {
                setChleni(res.data);
            }
        });
    }, []);

    const options = chleni.sort((a, b) => {
        var ai = a.user.lastname + " " + a.user.firstname + " " + a.user.patronymic;
        var bi = b.user.lastname + " " + b.user.firstname + " " + b.user.patronymic;
        if (ai < bi) {
          return -1;
        }
        if (ai > bi) {
          return 1;
        }
        // a должно быть равным b
        return 0;
      }).map(i => (
        <Option key={i.ID} value={i.ID}>{i.user.lastname + " " + i.user.firstname + " " + i.user.patronymic}</Option>
    ));
    return (
        <Form
            form={props.form}
            onFinish={props.submit}
            labelAlign={"left"}
            layout={"vertical"}
            initialValues={{
                // neobkhodimiiKvorum: 50,
                zasedanieRegionalnogoPravleniyaID: zasedanie.ID
            }}
        >

            <Form.Item
                preserve={"true"}
                hidden={true}
                name={"zasedanieRegionalnogoPravleniyaID"}
                label={"Заседание регионального правления"}
                rules={[{ required: true, message: 'Укажите заседание регионального правления!' }]}
            >
                <Input disabled />
            </Form.Item>

            <Form.Item
                name={"chlenFederatsiiID"}
                label={"Член федерации"}
                rules={[{ required: true, message: 'Укажите члена федерации!' }]}
            >
                <Select showSearch
                    filterOption={(input, option) =>
                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }>
                    {options}
                </Select>
            </Form.Item>

            {/* <Form.Item
                name={"nomerProtokolaZasedaniya"}
                label={"Номер протокола заседания"}
                rules={[{ required: true, message: 'Укажите номер протокола заседания!' }]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name={"dataZasedaniya"}
                label={"Дата заседания"}
                rules={[{ required: true, message: 'Укажите дату заседания!' }]}
            >
                <DatePicker locale={locale} />
            </Form.Item>
            <Form.Item
                name={"mestoProvedeniyaZasedaniyaID"}
                label={"Место проведения заседания"}
                rules={[{ required: true, message: 'Укажите место проведения заседания!' }]}
            >
                <Select showSearch
                    filterOption={(input, option) =>
                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }>
                    {options}
                </Select>
            </Form.Item>
            <Form.Item
                name={"neobkhodimiiKvorum"}
                label={"Необходимый кворум"}
                rules={[{ required: true, message: 'Укажите необходимый кворум!' }]}
            >
                <InputNumber min={0}
                    max={100}
                    formatter={value => `${value}%`}
                    parser={value => Number.parseFloat(value.replace('%', ''))}
                    precision={2}
                    step={0.05}
                    style={{ width: "50%" }} />
            </Form.Item> */}
        </Form>
    );
}
